import {NotificationContentBase, NotificationType} from '../../services/api.services';
import {dashboardExtDatasetLoadedMapping} from './dashboardExtDatasetLoadedMapping';
import {pivotExtDatasetLoadedMapping} from './pivotExtDatasetLoadedMapping';
import {schedulerReportMapping} from './schedulerReportMapping';
import {assetUnlockMapping} from './assetUnlockMapping';

export function mapContentToNotification(content: NotificationContentBase, time: string) {
    switch (content.type) {
      case NotificationType.SchedulerReportFinished:
        return schedulerReportMapping(content, time);

      case NotificationType.PivotExtDatasetLoaded:
        return pivotExtDatasetLoadedMapping(content, time);

      case NotificationType.DashboardExtDatasetLoaded:
        return dashboardExtDatasetLoadedMapping(content, time);

      case NotificationType.AssetUnlocked:
        return assetUnlockMapping(content, time);
    }
}


